import type { ReactElement } from 'react'
import { useSettings } from '~/state/queries'

/* Mixed down from the palette's own alarm colour rather than named outright, so
   the one bar that must never be missed still belongs to whichever design is on. */
const BANNER_CSS = `
.nw-provenance {
  background: var(--nw-alarm); color: var(--nw-alarm-ink);
  font: var(--nw-weight-body) var(--nw-text-meta)/var(--nw-text-meta-leading) var(--nw-font);
  padding: var(--nw-space-2) var(--nw-page-pad-x); text-align: center;
}
.nw-provenance strong { font-weight: var(--nw-weight-medium); letter-spacing: var(--nw-track-label); text-transform: uppercase; }
`

/**
 * Says what these figures are, whenever they are not real.
 *
 * Every number here looks equally plausible whether it came from a bank or from
 * the seed script, and for a while both were on the same page with nothing to
 * tell them apart. Cheap to render, and the one thing that stops a demo total
 * being read as somebody's net worth.
 */
export function ProvenanceBanner(): ReactElement | null {
  const settings = useSettings()
  if (settings.data === undefined) return null

  const { environment, demoData } = settings.data
  if (environment === 'production' && demoData !== true) return null

  const reason =
    demoData === true
      ? 'This database was seeded, so some holdings are fabricated.'
      : 'Not running as production.'

  return (
    <>
      <style>{BANNER_CSS}</style>
      <div className="nw-provenance" role="status">
        <strong>Test data</strong> — {reason} Figures here are not a net worth.
      </div>
    </>
  )
}
